<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <header class="mbs-wizard_form-header mb-0">
    @if (view === viewMode.Onboarding) {
      <div class="d-flex align-items-center justify-content-between border-bottom p-3">
        <h4
          class="mbs-wizard_form-title fw-bold mb-0"
          [attr.data-e2e]="elementSelectors.name.onboardingTitle">
          {{ 'wizards:select_files_and_folders' | i18next: { format: 'title' } }}
        </h4>

        <mbs-button
          type="primary"
          [isCtrl]="true"
          (click)="showLegend()">
          {{ 'wizards:show_legend_text' | i18next }}
        </mbs-button>
      </div>
    }
  </header>

  @if (view !== viewMode.Onboarding) {
    <div
      class="d-flex align-items-center w-100"
      [class.justify-content-between]="!isOffline && !isUnix && !showPlainText"
      [class.justify-content-end]="isOffline || isUnix || showPlainText"
      [class.mb-3]="!isOffline && ((!isUnix && !showPlainText) || !isRDMode)">
      @if (!isOffline && !isUnix && !showPlainText) {
        <mbs-button
          [attr.data-e2e]="elementSelectors.name.advancedOptionsBtnShare"
          (click)="addNetworkShare()">
          <img
            alt="Share Icon"
            class="share-btn-icon"
            [src]="shareIconPath" />
          {{ 'wizards:addNetworkShare' | i18next }}
        </mbs-button>
      }

      @if (!isOffline && !isRDMode) {
        <mbs-group-button [disabled]="!!editedString || loading">
          <mbs-button
            [active]="showPlainText"
            (click)="showHidePlaneTextHandler(true)">
            {{ 'wizards:show_plain_text' | i18next }}
          </mbs-button>
          <mbs-button
            [active]="!showPlainText"
            (click)="showHidePlaneTextHandler(false)">
            {{ 'wizards:hide_plain_text' | i18next }}
          </mbs-button>
        </mbs-group-button>
      }
    </div>
  }

  @if (!showPlainText) {
    <div
      [class.pt-3]="view === viewMode.Onboarding"
      [class.px-3]="view === viewMode.Onboarding">
      <mbs-card
        class="mbs-wizard-tree-card"
        [class.-invalid]="!stepForm.valid && !foldersForm.get('includeString').valid"
        [ngClass]="'-' + view">
        @if (loading) {
          <mbs-loader [size]="'small'"></mbs-loader>
        }

        @if (!treeData.length || loading) {
          <mbs-alert
            [attr.data-e2e]="elementSelectors.name.isLoadingOrNoSectionAlert"
            [icon]="true"
            [type]="mbsPopupType.warning">
            {{ loading ? 'Loading data...' : 'No sections available' }}
          </mbs-alert>
        }

        @if (!loading) {
          <mbs-tree
            mode="file"
            [attr.data-e2e]="elementSelectors.name.treeElement"
            [childrenManualControl]="true"
            [classesForRoot]="'treeElement mbs-wizard-tree mx-0 p-3 overflow-auto -' + view"
            [data]="treeData"
            [disableChildren]="false"
            [disableIfLoadingSubtree]="true"
            [dontSelectChildren]="false"
            [getItems]="getSubtree.bind(this)"
            [height]="view === viewMode.Onboarding ? '322px' : 'calc(70vh - ' + minusPixels + 'px)'"
            [itemClasses]="'what-to-backup-item'"
            [itemsCanBeHidden]="true"
            [lazy]="true"
            [loadMore]="getSubtree.bind(this)"
            (mbsChange)="changeTreeHandler($event)">
            <ng-template
              let-item
              treeElement>
              <span class="form-row align-items-center flex-nowrap mbs-wizard-tree-label-row">
                <span class="col-auto d-flex">
                  <img
                    alt=""
                    class="mbs-wizard-tree-label-img"
                    [src]="item.icon" />
                </span>
                <span class="col overflow-hidden">
                  <pre class="mbs-wizard-tree-label-pre-wrap mb-0">{{ item.label }}</pre>
                </span>
              </span>
            </ng-template>

            <ng-template
              let-item
              mbsTreeAppend>
              @if (item.canShowIBBAlert && item.checked) {
                <mbs-alert
                  class="mb-n1 ms-n2"
                  [attr.data-e2e]="elementSelectors.name.IBBAlert(item)"
                  [icon]="true"
                  [type]="mbsPopupType.info">
                  {{ 'wizards:whatBackup.IBBAlert.text' | i18next }}

                  @if (view === viewMode.Default) {
                    <a
                      target="_blank"
                      [helpLink]="'/backup/image-based-vs-files'">
                      {{ 'wizards:learn_more_link' | i18next }}
                    </a>
                  }

                  @if (view === viewMode.Onboarding) {
                    <mbs-button
                      [attr.data-e2e]="elementSelectors.name.IBBAlertButton(item)"
                      [isCtrl]="true"
                      [type]="'link'"
                      (click)="switchToIBB.emit(true)">
                      {{ 'wizards:whatBackup.IBBAlert.GSWButton' | i18next }}
                    </mbs-button>
                  }
                </mbs-alert>
              }
            </ng-template>
          </mbs-tree>
        }
      </mbs-card>
    </div>
  }

  @if (showPlainText) {
    <ng-container>
      <mbs-form-group [attr.data-e2e]="elementSelectors.name.plainTextFirstBlock">
        <div class="d-flex justify-content-between align-items-end w-100">
          <div class="d-flex flex-column">
            <span>
              {{ 'wizards:includeText' | i18next }}
              <span class="mbs-form_label-required">*</span>
            </span>
            <span class="text-gray-600">{{ 'wizards:includeTextDescription' | i18next }}</span>
          </div>

          @if (getErrorsCount()) {
            <mbs-tag
              class="bg-danger-30"
              [active]="true"
              [clickable]="false"
              [closable]="false"
              [noBorder]="true"
              [size]="size.sm">
              <span class="text-danger fw-bold">{{ 'wizards:textErrorsCount' | i18next: { count: getErrorsCount() } }}</span>
            </mbs-tag>
          }
        </div>

        <div
          class="mt-2 pt-1"
          [formGroup]="foldersForm">
          <mbs-input
            #includePathsInput
            formControlName="includePaths"
            [maxLength]="null"
            [placeholder]="isUnix ? unixPlaceholder : windowsPlaceholder"
            [resize]="'vertical'"
            [rows]="7"
            [type]="'textarea'"></mbs-input>

          @if (getErrorsCount()) {
            <mbs-card
              class="mbs-card-error overflow-auto mt-2"
              style="border-left: 3px solid #d3d4db; max-height: 96px"
              [border]="false"
              [customClasses]="'bg-secondary py-1 px-2'"
              [size]="size.xs">
              @for (error of includePathsErrors | keyvalue; track error.key) {
                <mbs-button
                  class="d-block text-start"
                  type="danger"
                  [isCtrl]="true"
                  [size]="size.sm"
                  (click)="focusPathLine(+error.key)">
                  {{ 'wizards:textErrorLine' | i18next: { line: +error.key + 1, message: getPathErrorMessage(error.value) } }}
                </mbs-button>
              }
            </mbs-card>
          }
        </div>
      </mbs-form-group>

      <mbs-form-group [attr.data-e2e]="elementSelectors.name.plainTextSecondBlock">
        <div class="d-flex justify-content-between align-items-end w-100">
          <div class="d-flex flex-column">
            <span>
              {{ 'wizards:excludeText' | i18next }}
              <span class="mbs-form_label-required">*</span>
            </span>
            <span class="text-gray-600">{{ 'wizards:excludeTextDescription' | i18next }}</span>
          </div>

          @if (getErrorsCount(false)) {
            <mbs-tag
              class="bg-danger-30"
              [active]="true"
              [clickable]="false"
              [closable]="false"
              [noBorder]="true"
              [size]="size.sm">
              <span class="text-danger fw-bold">{{ 'wizards:textErrorsCount' | i18next: { count: getErrorsCount(false) } }}</span>
            </mbs-tag>
          }
        </div>

        <div
          class="mt-2 pt-1"
          [formGroup]="foldersForm">
          <mbs-input
            #excludePathsInput
            formControlName="excludePaths"
            [maxLength]="null"
            [placeholder]="isUnix ? unixPlaceholder : windowsPlaceholder"
            [resize]="'vertical'"
            [rows]="7"
            [type]="'textarea'"></mbs-input>

          @if (getErrorsCount(false)) {
            <mbs-card
              class="mbs-card-error overflow-auto mt-2"
              style="border-left: 3px solid #d3d4db; max-height: 96px"
              [border]="false"
              [customClasses]="'bg-secondary py-1 px-2'"
              [size]="size.xs">
              @for (error of excludePathsErrors | keyvalue; track error.key) {
                <mbs-button
                  class="d-block text-start"
                  type="danger"
                  [isCtrl]="true"
                  [size]="size.sm"
                  (click)="focusPathLine(+error.key, false)">
                  {{ 'wizards:textErrorLine' | i18next: { line: +error.key + 1, message: getPathErrorMessage(error.value) } }}
                </mbs-button>
              }
            </mbs-card>
          }
        </div>
      </mbs-form-group>
    </ng-container>
  }
</section>

<ng-template #pasteTooltip>
  <div class="tooltip_content text-start">
    {{ 'wizards:past_tooltip_text' | i18next }}<br />
    @if (!isUnix) {
      <ng-container>
        D:\Folder 1<br />
        D:\Folder 2<br />
        D:\Folder 3
      </ng-container>
    } @else {
      <ng-container>
        /home/folder 1<br />
        /home/folder 2<br />
        /home/folder 3
      </ng-container>
    }
  </div>
</ng-template>

<ng-template #error>
  <mbs-form-group>
    <img
      alt="No Backup Plans"
      src="assets/clipboard.png" />
  </mbs-form-group>
  {{ 'shared:validation.read_permission_error' | i18next }}
</ng-template>
